module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "video-modal-wrapper"
  }, [_c('div', {
    staticClass: "video-modal-container modal-transition-container"
  }, [_vm._t("loading"), _vm._v(" "), _vm._t("body")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3916f751"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/VideoModal.vue
// module id = 1032
// module chunks = 1